// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1k-6";
export var headerCell = "_1k-2";
export var rowWrapper = "_1k-4";
export var stickyAggregationCell = "_1k-a";
export var stickyAggregationRow = "_1k-7";
export var stickyColumnCell = "_1k-9";
export var stickyColumnHeaderCell = "_1k-8";
export var table = "_1k-1";
export var virtualRowWrapper = "_1k-5";
export var virtualTableContainer = "_1k-0";
export var white = "_1k-3";